/**
 * Shared mapping between UI display values and database enum values for supplier state
 * Used by both filter config and column definitions
 */
export const STATE_ENUM_MAPPING = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Archived: 'ARCHIVED',
  Pending: 'PENDING',
} as const

export type StateDisplayValue = keyof typeof STATE_ENUM_MAPPING
export type StateDbValue = (typeof STATE_ENUM_MAPPING)[StateDisplayValue]

/** Default state when mapping fails or value is not found */
export const DEFAULT_STATE_DISPLAY_VALUE: StateDisplayValue = 'Active'

/**
 * Get all display values for state dropdown
 */
export const getStateDisplayValues = (): StateDisplayValue[] => {
  return Object.keys(STATE_ENUM_MAPPING) as StateDisplayValue[]
}

/**
 * Get all labels and values for state
 */
export const getStateValues = () => {
  return Object.values(STATE_ENUM_MAPPING)
}

/**
 * Check if string is a valid supplier state
 */
export const isValidSupplierState = (value: string) => {
  return (Object.values(STATE_ENUM_MAPPING) as string[]).includes(value)
}
